import React, { useEffect, useState, useRef } from "react";
import { NavLink } from "react-router-dom";
import "./PopOverMenu.css";

/*item = {
    id: "itemId",
    nav: {hasNav: boolean, address: "/..."},
    name: "itemName"
}*/
export const PopOverMenu = (props) => {
  const { menuItems, focusItem, id, menuRef, setSelectedItem } = props;

  const [toggleMenu, setToggleMenu] = useState(false);

  function handleToggle() {
    setToggleMenu(!toggleMenu);
  }

  function handleSelect(event) {
    setSelectedItem(event.target.getAttribute("value"));
    setToggleMenu(false)
  }

  /*
  useEffect(() => {
    menuRef.current = selectedItem;
  }, [selectedItem]);*/

  useEffect(() => {
    setToggleMenu(false);
    menuRef.current = null;
  }, [focusItem])

  return (
    <div className="pop_over_menu_wrapper">
      <div className="pop_over_menu_control" onClick={handleToggle}>
        <svg className="svg-icon" viewBox="0 0 20 20" width="2vw" height="2vw">
          <path
            fill="#000"
            d="M3.936,7.979c-1.116,0-2.021,0.905-2.021,2.021s0.905,2.021,2.021,2.021S5.957,11.116,5.957,10
								S5.052,7.979,3.936,7.979z M3.936,11.011c-0.558,0-1.011-0.452-1.011-1.011s0.453-1.011,1.011-1.011S4.946,9.441,4.946,10
								S4.494,11.011,3.936,11.011z M16.064,7.979c-1.116,0-2.021,0.905-2.021,2.021s0.905,2.021,2.021,2.021s2.021-0.905,2.021-2.021
								S17.181,7.979,16.064,7.979z M16.064,11.011c-0.559,0-1.011-0.452-1.011-1.011s0.452-1.011,1.011-1.011S17.075,9.441,17.075,10
								S16.623,11.011,16.064,11.011z M10,7.979c-1.116,0-2.021,0.905-2.021,2.021S8.884,12.021,10,12.021s2.021-0.905,2.021-2.021
								S11.116,7.979,10,7.979z M10,11.011c-0.558,0-1.011-0.452-1.011-1.011S9.442,8.989,10,8.989S11.011,9.441,11.011,10
								S10.558,11.011,10,11.011z"
          ></path>
        </svg>
      </div>
      <div
        className={`pop_over_menu_content_wrapper ${
          toggleMenu ? "pop_over_menu_active" : ""
        }`}
      >
        {menuItems.map((item, index) => (
          <div
            className={`pop_over_menu_item ${item.id}`}
            value={item.id}
            onClick={item.nav.hasNav ? undefined : handleSelect}
            key={index}
          >
            {item.nav.hasNav ? (
              <NavLink
                className="pop_over_menu_nav_link"
                to={item.nav.address}
                onClick={() => setToggleMenu(false)}
              >
                {item.name}
              </NavLink>
            ) : (
              item.name
            )}
          </div>
        ))}
      </div>
    </div>
  );
};
